import { Stack, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";

import AdminReadme from "./AdminReadme";

interface Props {
  label: string;
  readme: string[];
}

const AdminReadmeFormLabel: React.FC<Props> = ({ label, readme }: PropsWithChildren<Props>) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Typography variant="h6">{label}</Typography>
    <AdminReadme readme={readme} />
  </Stack>
);

export default AdminReadmeFormLabel;
